<div *ngIf="!loading ; else app_loading">
  <div class="p-3">
    <mdb-select [highlightColor]="'blue-grey'" [highlightFirst]="false" [outline]="true" [visibleOptions]="8" [options]="selectOptions" [placeholder]="'ADD' | translate" (selected)="getSelectedValue($event)"
    [filterEnabled]="true" [filterAutocomplete]="true" filterPlaceholder="{{ 'SEARCH' | translate }}" class="form-teal"></mdb-select>
  </div>
  <app-user-filter *ngFor="let pivot of pivots" (sendSelected)="receiveSelect($event)" [filters]="user.filter(pivot.uid.value)" [pivot]="pivot" [current]="current == pivot.uid.value"></app-user-filter>
</div>
<ng-template #app_loading>
  <app-loading></app-loading>
</ng-template>